var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "tab",
          "show-summary": "",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
          "table-attrs": _vm.tableAttrs,
        },
        scopedSlots: _vm._u([
          {
            key: "search-amountRange",
            fn: function ({ query }) {
              return [
                _c(
                  "div",
                  { staticClass: "amount-range" },
                  [
                    _c("el-input-number", {
                      attrs: {
                        controls: false,
                        placeholder: "最小金额",
                        min: 0,
                      },
                      model: {
                        value: query.minOrderAmount,
                        callback: function ($$v) {
                          _vm.$set(query, "minOrderAmount", $$v)
                        },
                        expression: "query.minOrderAmount",
                      },
                    }),
                    _c("span", { staticClass: "range-separator" }, [
                      _vm._v("至"),
                    ]),
                    _c("el-input-number", {
                      attrs: {
                        controls: false,
                        placeholder: "最大金额",
                        min: 0,
                      },
                      model: {
                        value: query.maxOrderAmount,
                        callback: function ($$v) {
                          _vm.$set(query, "maxOrderAmount", $$v)
                        },
                        expression: "query.maxOrderAmount",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "colMemberAccount",
            fn: function ({ row }) {
              return [
                _c("MemberAccountCell", {
                  attrs: {
                    row: row,
                    username: row.memberAccount,
                    uid: row.uid,
                    "vip-level": row.memberLevel,
                  },
                }),
              ]
            },
          },
          {
            key: "colOrderStatus",
            fn: function ({ row }) {
              return [
                row.status === 6
                  ? _c(
                      "div",
                      { staticClass: "status-fail-wrap" },
                      [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.getTagType(row.status)?.type,
                            },
                          },
                          [_vm._v(_vm._s(_vm.getTagType(row.status)?.label))]
                        ),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              content: `失败原因: ${row.thirdPayError || "--"}`,
                              placement: "top",
                              trigger: "hover",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-info info-icon",
                                }),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "mini",
                          type: _vm.getTagType(row.status)?.type,
                        },
                      },
                      [_vm._v(_vm._s(_vm.getTagType(row.status)?.label))]
                    ),
              ]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                _vm.canWithdrawRefund(row.status)
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.openRefundDialog(row)
                          },
                        },
                      },
                      [_vm._v(" 退款 ")]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "table-header",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "mini",
                      loading: _vm.exporting,
                      disabled: !_vm.payoutExportReady,
                    },
                    on: { click: _vm.handleExport },
                  },
                  [_vm._v(" 导出 Excel ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("WithdrawRefundDialog", {
        attrs: { visible: _vm.refundDialogVisible, row: _vm.refundRow },
        on: {
          "update:visible": function ($event) {
            _vm.refundDialogVisible = $event
          },
          success: _vm.handleRefundSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }